import React from "react";
import ReactTooltip from "react-tooltip";
var Tooltip = function (_a) {
    var id = _a.id, text = _a.text;
    return (React.createElement(ReactTooltip, { id: id, place: "right", textColor: "#fff", backgroundColor: "#32184B" },
        React.createElement("span", { style: {
                color: "white",
                fontSize: 14,
                fontWeight: 600,
                padding: "8px",
                width: "261px",
                display: "block",
                textAlign: "left",
                lineHeight: "19px",
            } }, text)));
};
export default Tooltip;
